module.exports = __webpack_public_path__ + "img/Ostsee.ee967bbe.svg";